<div class="right-side-bar-heading">
    KEEPING UP WITH caNanoLab
</div>

<div class="right-side-bar-content">
    <ul>
        <li>Stay connected and provide feedback through the <a target="+blank" href="https://nciphub.org/groups/cananolab_usability">caNanoLab User Hub</a>.</li>
        <li><a target="_blank" rel="nofollow noreferrer" href="https://wiki.nci.nih.gov/x/8RCcEw ">What’s New in caNanoLab?</a></li>
    </ul>
</div>
